// extracted by mini-css-extract-plugin
module.exports = {"bodyText":"_7DwkM0q","h5Text":"_1bJuedE","h4Text":"_1nDj1XT","h3Text":"_2YLPcl1","srOnly":"_2sMTye-","link":"_2fqAn5Z _7DwkM0q","container":"_2tINcUI","body":"_1UGQQJn _7DwkM0q"};